import * as colors from "./colors";
/**
 * The styled-components theme object used by bonfire.
 *
 * This can be used alongside a ThemeProvider to affect the global constants that bonfire
 * uses.
 */
export var theme = {
    // Namespace our theme, to avoid conflicts when merged with other themes.
    bonfire: {
        /**
         * The standard color pallet for campout applications.
         */
        colors: colors
    }
};
//# sourceMappingURL=index.js.map